import React, { useState , useContext, useEffect } from "react";
import { Col, Row, Form, Button, Spinner, FormGroup } from "react-bootstrap";
import {  useForm } from "react-hook-form";
import "./Home.css";
import { FaPlus } from "react-icons/fa";
import Result from "../Result/Result";
import { toast } from 'react-hot-toast';
import Endpoints from "../../constants/Endpoints";
import Variables from "../../constants/Variables";
import axios from "axios";
import { AuthContext } from "../../contexts/AuthProvider";
import Sidebar from "./Sidebar";
import Loader from "../Loader/Loader";
function Home() {
  const { user } = useContext(AuthContext);
  const [proposalData, setProposalData] = useState(null);
  const [clientData, setClientData] = useState('');
  const [isLoading, setLoading] = useState(false);
  const techStacks = Variables.techStacks;
  const [questions, setQuestions] = useState(null);
  const [showText, setShowText] = useState(false);
  const { register, handleSubmit, reset } = useForm();

  // New code start
    const [fields, setFields] = useState(['']);
      const handleAddField = () => {
        if (fields[fields.length-1] != "") {
          setFields([...fields, '']);
            }
          };

      const handleFieldChange = (index, event) => {
        const fieldData = [...fields];
        fieldData[index] = event.target.value;
        setFields(fieldData);
        // console.log("Data", fieldData);
      };
  // New code end

  const onSubmit = async (data) => {
    data.clientQues=fields;
  
    if (data?.techStack != 'Select The Tech Stack') {
      setLoading(true);
      const formData = {
        "techStack": data?.techStack,
        "jobTitle": data?.jobTitle,
        "jobDescription": data?.jobDes,
        "clientQuestions": data?.clientQues,
        "email" : user.email
    }
   
      setShowText(true);
    
    // console.log("Form Data", formData);
    setClientData(data?.clientName);
    await axios.post(Endpoints.addInfo, formData)
    // await axios.get("https://jsonplaceholder.typicode.com/todos/1")
    .then(response => {
      let result = response.data.msg;
      // console.log('response is',response)
      if (result[0] === '\n') {
        result = result.slice(1);
      }
      
      // console.log(result);
      setProposalData(result);
      setQuestions(response.data.answers)
      setLoading(false);
      setShowText(false);

    })
    .catch(error => {
      toast.error(error.message);
      console.log(error);
      setLoading(false);
      setShowText(false);
    });
  }else{
    toast.error('Fill all the required fileds ');
    setShowText(false);
    reset();
  }
  };

  return (
    <div className="row">
     <div className="col-3">
      <Sidebar disable = {showText}/> 
     </div>
     <div className="col-9">
      <div className={`rt-home mt-5 ${showText ? 'bg-blur': '' }`}>
        {proposalData === null ? (
          <Row className="">
            <Col md="9">
              <Form
                className="mt-3 bg-form p-5 shadow mb-3 rounded info-form"
                onSubmit={handleSubmit(onSubmit)}
                >
                  <fieldset disabled={showText} >  
                <div className="article-title mb-3">
                  <h3 className="title">Please fill up the below information to proceed</h3>
                </div>
                <Row>
                  <Col>
                    <Form.Group
                      className="mb-4"
                    >
                      <Form.Label>Client Name</Form.Label>
                      <Form.Control
                        {...register("clientName", { required: false })}
                        type="text"
                        placeholder="Mr John"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-4">
                      <Form.Label>Tech Stack*</Form.Label>
                      <Form.Select aria-label="Default select example"  {...register("techStack", { required: true })}>
                        <option>Select The Tech Stack</option>
                        {techStacks.map((item, index) => (
                          <option key={index} value={item}>{item}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                    <Form.Group
                      className="mb-4"
                    >
                      <Form.Label>Job Title*</Form.Label>
                      <Form.Control
                        {...register("jobTitle", { required: true })}
                        type="text"
                        placeholder="Title of the job"
                      />
                    </Form.Group>              
                  </Row>

                <Row>
                  <FormGroup
                    className="mb-4"
                  >
                    <Form.Label>Job Description*</Form.Label>
                    <Form.Control 
                      as="textarea"
                      placeholder="Description of the job that shared by client"
                      rows={6}
                      {...register("jobDes", { required: true })}
                    />
                  </FormGroup>
                </Row>

                <Row>
                  <FormGroup>
                    <Form.Label>Client Questions</Form.Label>
                      <div>
                        { fields.map((field, index) => (
                          <Form.Control 
                            as="textarea"
                            className="mb-4"
                            placeholder="Ask your question"
                            rows={3}
                            key={index} 
                            value={field}                               
                            onChange={(e) => handleFieldChange(index, e)}
                            // {...register("clientQues", { required: false })}
                          />
                        ))}
                        <div className="btn-container">
                          <div className="new-field-btn" onClick={handleAddField}><FaPlus />Add Question</div>
                        </div>
                      </div>
                  </FormGroup>
                </Row>

                <Button
                  className="mt-4 submit-btn"
                  variant="primary"
                  type="submit">
                    Submit
                </Button>

              </fieldset>
              </Form>
            </Col>
          </Row>
        ) : (
          <Result
            clientName = {clientData}
            proposalLetter = {proposalData}
            questions = {questions}
          />
        )}
      </div>

      <div className={`${showText ? 'bg-text': 'd-none' }`}>
        <div className="loading">
          <Spinner
            as="span"
            animation="border"
            variant="primary"
            role="status"
            aria-hidden="true"                      
          />
         <p>Please wait a moment while we process your request.</p>
                        
        </div>
      
      </div>
    </div>
  </div>
  );
}

export default Home;
